import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment-timezone';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import service from '../services';
import commonImage from '../commonImage';
import { AD_NAVIGATION_TYPE_KEY } from '../cosntants';
import TextField from '../component/TextField';
import AppRoutePicker from '../component/Mobile/AppRoutePicker';
import UploadForm from '../component/UploadForm';
import Loader from '../component/loader';
import PopUpCustomAll from '../component/fpg/create/popUpCustomAll';
import DeletefileIcon from '../icons/DeletefileIcon';
import EditIcon from '../icons/EditIcon';
import FpgPlusIcon from '../icons/fpgplusicon';
import FpgMinusIcon from '../icons/fpgminusicon';
import DraggerIcon from '../icons/draggericon';
import delet from '../assets/images/delet.svg';

const DisplayScreeningDate = (dateNew, locationType, formate) => {
  const formateCheck = formate || 'MMM. D, h:mm A';
  if (locationType === '1') {
    return moment(new Date(dateNew)).tz('America/Denver').format(formateCheck);
  }
  return moment(new Date(dateNew)).local().format(formateCheck);
};

class ScheduleAds extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaderFlag: false,
      adsList: [],
      errorMsg: false,
      errorMsgShow: '',
      // Delete confirmation
      deleteAdPopup: false,
      deleteAdId: null,
      // Popup state (shared for add and edit)
      showAdPopup: false,
      popupMode: 'add',       // 'add' | 'edit'
      popupAd: null,
      popupInitialData: null,
      popupIsEdited: false,
      popupImagePreloader: false,
      popupMobileWebImagePreloader: false,
      popupWebImagePreloader: false,
      lastUpdated: null,
      lastUpdatedBy: '',
      currentPage: 0,
      offset: 0,
      perPage: 20,
      pageCount: 0,
    };

    this.popupValidator = new SimpleReactValidator({
      autoForceUpdate: this,
      validators: {
        urlValidation: {
          message: 'Please enter a valid URL',
          rule: (val, params, validator) =>
            validator.helpers.testRegex(
              val,
              /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
            ) && params.indexOf(val) === -1,
          required: false,
        },
      },
    });

    this.apiserve = new service();
  }

  mapDocToLocal = (doc) => {
    const typeMap = { 1: AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL, 2: AD_NAVIGATION_TYPE_KEY.APP_PAGE_NAVIGATION };
    return {
      _id: doc._id,
      adTitle: doc.adTitle || '',
      adImage: doc.adImage || '',
      adMobileWebImage: doc.adMobileWebImage || '',
      adWebImage: doc.adWebImage || '',
      adWebRedirect: doc.adWebRedirect || '',
      adStartDate: doc.adStartDate ? new Date(doc.adStartDate) : null,
      adEndDate: doc.adEndDate ? new Date(doc.adEndDate) : null,
      adNavigationType: {
        type: typeMap[doc.adNavigationType?.type] || AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL,
        value: doc.adNavigationType?.value || '',
      },
      adNavigationParams: (doc.adNavigationParams || []).map(p => ({ key: p.key || '', value: p.value || '' })),
      isActive: doc.isActive !== false,
    };
  };

  markPopupEdited = () => {
    if (this.state.popupMode === 'edit' && this.state.popupInitialData) {
      const isDirty = !isEqual(this.state.popupInitialData, this.state.popupAd);
      if (this.state.popupIsEdited !== isDirty) {
        this.setState({ popupIsEdited: isDirty });
      }
    }
  };

  componentDidMount = () => {
    this.setupSocketEvents();
    this.getData(this.state.offset, this.state.perPage);
  };

  componentWillUnmount = () => {
    if (this.sub) this.sub.unsubscribe();
  };

  setupSocketEvents = () => {
    this.sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case 'scheduleAds|getAllList':
          if (!response.error && response.data?.data?.docs) {
            const docs = response.data.data.docs;
            const adsList = docs.map(this.mapDocToLocal);
            const totalPages = response.data.data.totalPages || 0;
            const latestRecord = [...docs].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0];
            const lastUpdated = latestRecord?.updatedAt || null;
            const lastUpdatedBy = latestRecord?.updatedBy
              ? `${latestRecord.updatedBy.fname || ''} ${latestRecord.updatedBy.lname || ''}`.trim()
              : '';
            this.setState({
              adsList,
              loaderFlag: false,
              lastUpdated,
              lastUpdatedBy,
              pageCount: totalPages,
            });
          } else {
            this.setState({ loaderFlag: false });
          }
          break;

        case 'scheduleAds|create':
        case 'scheduleAds|edit':
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error || 'An error occurred' });
          } else {
            this.setState({ loaderFlag: false });
            this.apiserve.success(response.event === 'scheduleAds|create' ? 'Ad created successfully.' : 'Ad updated successfully.');
            this.getData(this.state.offset, this.state.perPage);
          }
          break;

        case 'scheduleAds|remove':
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error || 'Failed to remove ad' });
          } else {
            this.setState({ loaderFlag: false });
            this.apiserve.success('Ad removed successfully.');
            this.getData(this.state.offset, this.state.perPage);
          }
          break;

        case 'scheduleAds|changeOrder':
          if (response.error) {
            this.setState({ loaderFlag: false, errorMsg: true, errorMsgShow: response.data?.error || 'Failed to update order' });
            this.getData(this.state.offset, this.state.perPage);
          } else {
            this.setState({ loaderFlag: false });
          }
          break;

        default:
          break;
      }
    });
  };

  getData = (offset, limit) => {
    this.setState({ loaderFlag: true });
    this.apiserve.sendevent('scheduleAds|getAllList', { page: offset, limit });
  };

  validateModel = () => {
    this.setState({ errorMsg: false });
  };

  removeAd = (id) => {
    this.setState({ deleteAdPopup: true, deleteAdId: id });
  };

  confirmRemoveAd = () => {
    this.setState({ loaderFlag: true, deleteAdPopup: false });
    this.apiserve.sendevent('scheduleAds|remove', { scheduleAdId: this.state.deleteAdId });
  };

  // --- Popup methods (shared for add and edit) ---

  openAddPopup = () => {
    if (this.state.adsList.length >= 30) return;
    this.popupValidator.hideMessages();
    this.setState({
      showAdPopup: true,
      popupMode: 'add',
      popupInitialData: null,
      popupIsEdited: false,
      popupAd: {
        adTitle: '',
        adImage: '',
        adMobileWebImage: '',
        adWebImage: '',
        adWebRedirect: '',
        adStartDate: null,
        adEndDate: null,
        adNavigationType: { type: AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL, value: '' },
        adNavigationParams: [{ key: '', value: '' }],
        isActive: true,
      },
      popupImagePreloader: false,
      popupMobileWebImagePreloader: false,
      popupWebImagePreloader: false,
    });
  };

  openEditPopup = (item) => {
    this.popupValidator.hideMessages();
    const converted = {
      ...item,
      adStartDate: this.getMtDateForPicker(item.adStartDate),
      adEndDate: this.getMtDateForPicker(item.adEndDate),
    };
    const snapshot = cloneDeep(converted);
    this.setState({
      showAdPopup: true,
      popupMode: 'edit',
      popupAd: cloneDeep(converted),
      popupInitialData: snapshot,
      popupIsEdited: false,
      popupImagePreloader: false,
      popupMobileWebImagePreloader: false,
      popupWebImagePreloader: false,
    });
  };

  closeAdPopup = () => {
    this.popupValidator.hideMessages();
    this.setState({ showAdPopup: false, popupAd: null, popupInitialData: null, popupIsEdited: false });
  };

  handlePopupFieldChange = (field, value) => {
    this.setState(prev => ({
      popupAd: { ...prev.popupAd, [field]: value }
    }), () => this.markPopupEdited());
  };

  handlePopupNavTypeChange = (value) => {
    this.popupValidator.hideMessages();
    this.setState(prev => ({
      popupAd: { ...prev.popupAd, adNavigationType: { type: value, value: '' } }
    }), () => this.markPopupEdited());
  };

  handlePopupNavValueChange = (val) => {
    this.setState(prev => ({
      popupAd: { ...prev.popupAd, adNavigationType: { ...prev.popupAd.adNavigationType, value: val } }
    }), () => this.markPopupEdited());
  };

  handlePopupParamChange = (paramIndex, field, value) => {
    this.setState(prev => {
      const newParams = prev.popupAd.adNavigationParams.map((p, idx) =>
        idx === paramIndex ? { ...p, [field]: value } : p
      );
      return { popupAd: { ...prev.popupAd, adNavigationParams: newParams } };
    }, () => this.markPopupEdited());
  };

  addPopupParam = () => {
    this.setState(prev => ({
      popupAd: {
        ...prev.popupAd,
        adNavigationParams: [...prev.popupAd.adNavigationParams, { key: '', value: '' }],
      }
    }), () => this.markPopupEdited());
  };

  removePopupParam = (paramIndex) => {
    this.setState(prev => ({
      popupAd: {
        ...prev.popupAd,
        adNavigationParams: prev.popupAd.adNavigationParams.filter((_, idx) => idx !== paramIndex),
      }
    }), () => this.markPopupEdited());
  };

  // field: 'adImage' (mobile app, 2:1) | 'adMobileWebImage' (mobile web, 5:2) | 'adWebImage' (website, 8:1)
  onPopupChangeFile = (e, field, ratio, ratioLabel) => {
    e.preventDefault();
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      const fileSize = Math.round(file.size / 1024);
      if (fileSize >= 2048) {
        this.setState({ errorMsg: true, errorMsgShow: 'Please upload a file smaller than 2 MB' });
        return;
      }
      if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
        const image = new Image();
        image.src = event.target.result;
        image.onload = () => {
          if (Math.abs(image.width / image.height - ratio) > ratio * 0.025) {
            this.setState({ errorMsg: true, errorMsgShow: `Please upload a ${ratioLabel} aspect ratio image` });
            return;
          }
          this.popupImageUpload(file, event.target.result, field);
        };
        image.onerror = () => {
          this.setState({ errorMsg: true, errorMsgShow: 'Failed to load image. Please try a different file.' });
        };
      } else {
        this.setState({ errorMsg: true, errorMsgShow: 'Please upload a file for PNG, JPG or JPEG' });
      }
    };
  };

  popupImageUpload = (file, img, field) => {
    const loaderKey = {
      adImage: 'popupImagePreloader',
      adMobileWebImage: 'popupMobileWebImagePreloader',
      adWebImage: 'popupWebImagePreloader',
    }[field];
    this.setState({ [loaderKey]: true });
    const fileSet = commonImage(file, false, this.apiserve.formbucketAds, img);
    fileSet.then((value) => {
      this.setState(prev => ({
        popupAd: { ...prev.popupAd, [field]: value || '' },
        [loaderKey]: false,
      }), () => this.markPopupEdited());
    });
  };

  getMtDateForPicker = (date) => {
    if (!date) return null;
    const ABBR = moment.tz("America/Denver").format("z");
    const offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    return moment(date).subtract(offDifference, 'minutes').toDate();
  };

  getMtTime = (date) => {
    if (!date) return null;
    //Get offset from mountain time using UTC
    //change 360 t0 420
    let ABBR = moment.tz("America/Denver").format("z");
    let offDifference = moment().utcOffset() + (ABBR === 'MDT' ? 360 : 420);
    // add that offset in date
    return moment(date).add(offDifference, 'minutes').toISOString()
  }

  savePopupAd = (e) => {
    e.preventDefault();
    if (!this.popupValidator.allValid()) {
      this.popupValidator.showMessages();
      this.forceUpdate();
      return;
    }
    const ad = this.state.popupAd;
    if (ad.adEndDate && ad.adStartDate && ad.adEndDate <= ad.adStartDate) {
      this.setState({ errorMsg: true, errorMsgShow: 'End date must be after start date' });
      return;
    }
    this.setState({ loaderFlag: true });
    const payload = {
      adTitle: ad.adTitle,
      adImage: ad.adImage,
      adMobileWebImage: ad.adMobileWebImage,
      adWebImage: ad.adWebImage,
      adWebRedirect: (ad.adWebRedirect || '').trim(),
      adStartDate: ad.adStartDate ? this.getMtTime(ad.adStartDate) : '',
      adEndDate: ad.adEndDate ? this.getMtTime(ad.adEndDate) : '',
      adNavigationType: { type: ad.adNavigationType.type, value: ad.adNavigationType.value },
      adNavigationParams: ad.adNavigationParams,
      isActive: ad.isActive,
    };
    if (this.state.popupMode === 'edit') {
      this.apiserve.sendevent('scheduleAds|edit', { scheduleAdId: ad._id, ...payload });
    } else {
      this.apiserve.sendevent('scheduleAds|create', payload);
    }
    this.closeAdPopup();
  };

  onDragEnd = (result) => {
    if (!result.destination || result.destination.index === result.source.index) return;
    const { offset, perPage } = this.state;
    const pageBase = offset > 0 ? (offset - 1) * perPage : 0;
    const reordered = Array.from(this.state.adsList);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);
    const order = reordered.map((item, idx) => ({ scheduleAdId: item._id, sortIndex: pageBase + idx }));
    this.setState({ adsList: reordered, loaderFlag: true });
    this.apiserve.sendevent('scheduleAds|changeOrder', { order });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage + 1;
    const tbl = document.querySelector('.product_list_tbl');
    if (tbl) tbl.scrollTo(0, 0);
    this.setState({ currentPage: selectedPage, offset, loaderFlag: true }, () => {
      this.getData(offset, this.state.perPage);
    });
  };

  render() {
    const { adsList, lastUpdated, lastUpdatedBy, loaderFlag, showAdPopup, popupAd, popupMode, popupIsEdited, popupImagePreloader, popupMobileWebImagePreloader, popupWebImagePreloader, currentPage, pageCount, perPage } = this.state;
    const pageOffset = currentPage * perPage;

    return (
      <div className="schedule_ads_tab_content">

        {/* Last Updated meta bar */}
        {lastUpdated && (
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <p></p>
            <p className="update_date">
              Last Update: {DisplayScreeningDate(lastUpdated, '1', 'hh:mm A')} MT -{DisplayScreeningDate(lastUpdated, '1', 'MM/DD/YYYY')} Last Updated By: {lastUpdatedBy || ''}
            </p>
          </div>
        )}

        {/* Table */}
        <div className="category_add_edit">
          <div className="table_wrap product_list_tbl film_list_table striped_table">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Ad Title</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Navigation Type</th>
                  <th>Active</th>
                  <th>Action</th>
                </tr>
              </thead>
              <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="schedule-ads-list">
                  {(provided) => (
                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                      {adsList.length === 0 ? (
                        <tr>
                          <td colSpan="8" style={{ textAlign: 'center', padding: '30px' }}>
                            No ads added yet. Click <strong>+</strong> to add your first ad.
                          </td>
                        </tr>
                      ) : (
                        adsList.map((item, i) => (
                          <Draggable key={item._id} draggableId={item._id} index={i}>
                            {(drag, snapshot) => (
                              <tr
                                ref={drag.innerRef}
                                {...drag.draggableProps}
                                style={{
                                  ...drag.draggableProps.style,
                                  background: snapshot.isDragging ? '#f0f0f0' : '',
                                }}
                              >
                                <td {...drag.dragHandleProps} style={{ cursor: 'grab', width: '30px' }}>
                                  <DraggerIcon />
                                </td>
                                <td>{pageOffset + i + 1}</td>
                                <td>{item.adTitle || '—'}</td>
                                <td>
                                  {item.adStartDate
                                    ? DisplayScreeningDate(item.adStartDate, '1', 'MMM DD YYYY - h:mm A')
                                    : '—'}
                                </td>
                                <td>
                                  {item.adEndDate
                                    ? DisplayScreeningDate(item.adEndDate, '1', 'MMM DD YYYY - h:mm A')
                                    : '—'}
                                </td>
                                <td>
                                  {item.adNavigationType?.type === AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL ? 'External URL' : 'App Page'}
                                </td>
                                <td>{item.isActive ? 'Yes' : 'No'}</td>
                                <td>
                                  <div className="action_wrap d_flex">
                                    <span className="cat_edit pointer" onClick={() => this.openEditPopup(item)}>
                                      <EditIcon />
                                    </span>
                                    <span className="remove_cat pointer" onClick={() => this.removeAd(item._id)}>
                                      <img src={delet} alt="delete" />
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))
                      )}
                      {provided.placeholder}
                    </tbody>
                  )}
                </Droppable>
              </DragDropContext>
            </table>
          </div>
          {pageCount > 1 && (
            <div className="custom-pagination pagination_mb">
              <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={currentPage}
              />
            </div>
          )}
        </div>

        {/* Add / Edit Popup — uses existing user_popup / cat_modal_inner pattern */}
        <div className={`user_popup ${showAdPopup ? 'active' : ''}`}>
          <span className="popup_overlay" onClick={this.closeAdPopup}></span>
          <div className="cat_modal_inner sd_schedule_ad_modal">
            <p className="cat_title text_center">
              {popupMode === 'edit' ? 'Edit Schedule Ad' : 'Add Schedule Ad'}
            </p>
            {popupAd && (
              <form>
                <div className="sd_popup_layout">
                  {/* Left: image uploads */}
                  <div className="sd_popup_img_col">
                    <p className="sd_img_label">Mobile App Image Upload</p>
                    <div className="sd_popup_img_box sd_img_mobile loader-main">
                      {popupImagePreloader ? (
                        <Loader />
                      ) : (
                        <img
                          src={popupAd.adImage ? this.apiserve.imageUrl + popupAd.adImage : '/images/image-placeholder.png'}
                          onError={e => { e.target.src = '/images/image-placeholder.png'; }}
                          alt="Mobile App Image Upload preview"
                        />
                      )}
                      <UploadForm item={popupAd} handleImage={e => this.onPopupChangeFile(e, 'adImage', 2, '2:1')} />
                      {popupAd.adImage && (
                        <span
                          className="remove_file pointer"
                          onClick={() => this.setState(prev => ({ popupAd: { ...prev.popupAd, adImage: '' } }), () => this.markPopupEdited())}
                        >
                          <DeletefileIcon />
                        </span>
                      )}
                    </div>
                    <span className="error_note">Max Size 2MB · 2:1 Ratio</span>
                    <span style={{ color: 'red' }}>
                      {this.popupValidator.message('Mobile App Image Upload', popupAd.adImage, 'required')}
                    </span>

                    <p className="sd_img_label">Mobile Web Image Upload</p>
                    <div className="sd_popup_img_box sd_img_mobile_web loader-main">
                      {popupMobileWebImagePreloader ? (
                        <Loader />
                      ) : (
                        <img
                          src={popupAd.adMobileWebImage ? this.apiserve.imageUrl + popupAd.adMobileWebImage : '/images/image-placeholder.png'}
                          onError={e => { e.target.src = '/images/image-placeholder.png'; }}
                          alt="Mobile Web Image Upload preview"
                        />
                      )}
                      <UploadForm item={popupAd} handleImage={e => this.onPopupChangeFile(e, 'adMobileWebImage', 5 / 2, '5:2')} />
                      {popupAd.adMobileWebImage && (
                        <span
                          className="remove_file pointer"
                          onClick={() => this.setState(prev => ({ popupAd: { ...prev.popupAd, adMobileWebImage: '' } }), () => this.markPopupEdited())}
                        >
                          <DeletefileIcon />
                        </span>
                      )}
                    </div>
                    <span className="error_note">Max Size 2MB · 5:2 Ratio</span>

                    <p className="sd_img_label">Website Image Upload</p>
                    <div className="sd_popup_img_box sd_img_web loader-main">
                      {popupWebImagePreloader ? (
                        <Loader />
                      ) : (
                        <img
                          src={popupAd.adWebImage ? this.apiserve.imageUrl + popupAd.adWebImage : '/images/image-placeholder.png'}
                          onError={e => { e.target.src = '/images/image-placeholder.png'; }}
                          alt="Website Image Upload preview"
                        />
                      )}
                      <UploadForm item={popupAd} handleImage={e => this.onPopupChangeFile(e, 'adWebImage', 8, '8:1')} />
                      {popupAd.adWebImage && (
                        <span
                          className="remove_file pointer"
                          onClick={() => this.setState(prev => ({ popupAd: { ...prev.popupAd, adWebImage: '' } }), () => this.markPopupEdited())}
                        >
                          <DeletefileIcon />
                        </span>
                      )}
                    </div>
                    <span className="error_note">Max Size 2MB · 8:1 Ratio</span>
                    <span style={{ color: 'red' }}>

                    </span>
                  </div>

                  {/* Right: form fields */}
                  <div className="sd_popup_fields_col">
                    {/* Ad Title */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Ad Title</label>
                        <div className="field_input relative">
                          <textarea
                            value={popupAd.adTitle}
                            onChange={e => this.handlePopupFieldChange('adTitle', e.target.value)}
                            placeholder="Enter ad title"
                          />
                          <span style={{ color: 'red' }}>
                            {this.popupValidator.message('Ad Title', popupAd.adTitle, 'required')}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Ad Start Date */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Start Date</label>
                        <div className="field_input relative">
                          <DatePicker
                            selected={popupAd.adStartDate}
                            onChange={date => this.handlePopupFieldChange('adStartDate', date)}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeIntervals={15}
                            placeholderText="Select start date & time"
                            className="datepicker_input"
                            minDate={
                              popupAd.adStartDate && new Date(popupAd.adStartDate) < new Date()
                                ? new Date(popupAd.adStartDate)
                                : new Date()
                            }
                          />
                          <span style={{ color: 'red' }}>
                            {this.popupValidator.message('Start Date', popupAd.adStartDate, 'required')}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Ad End Date */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>End Date</label>
                        <div className="field_input relative">
                          <DatePicker
                            selected={popupAd.adEndDate}
                            onChange={date => this.handlePopupFieldChange('adEndDate', date)}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            timeIntervals={15}
                            placeholderText="Select end date & time"
                            className="datepicker_input"
                            minDate={popupAd.adStartDate || new Date()}
                          />
                          <span style={{ color: 'red' }}>
                            {this.popupValidator.message('End Date', popupAd.adEndDate, 'required')}
                            {popupAd.adEndDate && popupAd.adStartDate && popupAd.adEndDate <= popupAd.adStartDate
                              ? <span>End date must be after start date</span>
                              : null}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Web Redirect */}
                    <div className="field_row horizontal_field d_flex">
                      <TextField
                        name="adWebRedirect"
                        label="Web Redirect"
                        type="text"
                        value={popupAd.adWebRedirect}
                        onChange={e => this.handlePopupFieldChange('adWebRedirect', e.target.value)}
                        placeholder="https://www.example.com"
                        fpgerror={popupAd.adWebRedirect ? this.popupValidator.message('Web Redirect', popupAd.adWebRedirect.trim(), 'urlValidation') : ''}
                      />
                    </div>

                    {/* Navigation Type */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>App Navigation</label>
                        <div className="field_input relative">
                          <div className="sd_radio_row">
                            <label className="sd_radio_label">
                              <input
                                type="radio"
                                name="popupAdNavType"
                                value={AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL}
                                checked={popupAd.adNavigationType.type === AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL}
                                onChange={() => this.handlePopupNavTypeChange(AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL)}
                              />
                              External URL
                            </label>
                            <label className="sd_radio_label">
                              <input
                                type="radio"
                                name="popupAdNavType"
                                value={AD_NAVIGATION_TYPE_KEY.APP_PAGE_NAVIGATION}
                                checked={popupAd.adNavigationType.type === AD_NAVIGATION_TYPE_KEY.APP_PAGE_NAVIGATION}
                                onChange={() => this.handlePopupNavTypeChange(AD_NAVIGATION_TYPE_KEY.APP_PAGE_NAVIGATION)}
                              />
                              App Page
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Navigation URL or App Page (single value field) */}
                    {popupAd.adNavigationType.type === AD_NAVIGATION_TYPE_KEY.EXTERNAL_URL ? (
                      <div className="field_row horizontal_field d_flex">
                        <TextField
                          name="adNavigationValue"
                          label="Nav URL"
                          type="text"
                          value={popupAd.adNavigationType.value}
                          onChange={e => this.handlePopupNavValueChange(e.target.value)}
                          placeholder="https://..."
                          fpgerror={popupAd.adNavigationType.value ? this.popupValidator.message('Navigation Value', popupAd.adNavigationType.value, 'urlValidation') : ''}
                        />
                      </div>
                    ) : (
                      <div className="field_row horizontal_field d_flex">
                        <div className="field_row_inner">
                          <label>App Page</label>
                          <div className="field_input relative">
                            <AppRoutePicker
                              value={popupAd.adNavigationType.value}
                              onChange={val => this.handlePopupNavValueChange(val)}
                              error={''}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Navigation Params */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label>Nav Params</label>
                        <div className="field_input relative">
                          <div className="sd_nav_params">
                            {popupAd.adNavigationParams.map((param, pIdx) => (
                              <div key={pIdx} className="sd_nav_param_row">
                                <input
                                  type="text"
                                  value={param.key}
                                  placeholder="key"
                                  onChange={e => this.handlePopupParamChange(pIdx, 'key', e.target.value)}
                                  autoComplete="off"
                                />
                                <input
                                  type="text"
                                  value={param.value}
                                  placeholder="value"
                                  onChange={e => this.handlePopupParamChange(pIdx, 'value', e.target.value)}
                                  autoComplete="off"
                                />
                                <span className="pointer" onClick={this.addPopupParam}>
                                  <FpgPlusIcon width="18" height="18" color="#000000" stroke="#ffffff" />
                                </span>
                                {popupAd.adNavigationParams.length > 1 && (
                                  <span className="pointer" onClick={() => this.removePopupParam(pIdx)}>
                                    <FpgMinusIcon width="18" height="18" color="#000000" stroke="#ffffff" />
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Active toggle */}
                    <div className="field_row horizontal_field d_flex">
                      <div className="field_row_inner">
                        <label className="null">Active</label>
                        <label className="switch" style={{minWidth:'auto'}}>
                          <input type="checkbox" checked={popupAd.isActive} onChange={() => this.handlePopupFieldChange('isActive', !popupAd.isActive)} />
                          <span className="slider round"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cat_btns text_center">
                  <button type="button" onClick={this.closeAdPopup}>
                    CANCEL
                  </button>
                  <button
                    type="button"
                    disabled={popupMode === 'edit' && !popupIsEdited}
                    className={popupMode === 'edit' && !popupIsEdited ? '' : 'active'}
                    onClick={e => this.savePopupAd(e)}
                  >
                    SAVE
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>

        {/* Error popup */}
        <div className={`user_popup ${this.state.errorMsg ? 'active' : ''}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button className="small_btn active" onClick={this.validateModel}>OK</button>
              </div>
            </div>
          </div>
        </div>

        {/* Remove ad confirmation */}
        {this.state.deleteAdPopup && (
          <PopUpCustomAll
            HeaderName="Remove Ad?"
            insideDetails="Are You Sure?"
            insideData="You want to remove this ad"
            popupState={() => this.setState({ deleteAdPopup: false, deleteAdId: null })}
            yesPopUp={this.confirmRemoveAd}
          />
        )}

        {loaderFlag && <Loader />}
      </div>
    );
  }
}

export default ScheduleAds;
